<template>
    <ul class="list-group">
        <li class="list-group-item bg-light-danger" v-for="(item,index) in value" :key="index">{{item}}</li>
    </ul>
</template>

<script>

export default {
    props:{
        value:Array
    },
    
}
</script>

<style>

</style>